export default __webpack_public_path__ + "static/media/Aura.f48a2fb3.svg";